import { HttpErrorResponse } from '@angular/common/http';

export function extractHttpErrorMessage(errorResponse: HttpErrorResponse | any): string {
  if (!errorResponse) {
    return '';
  }

  const body = errorResponse.error;

  if (typeof body === 'string') {
    return body;
  }

  if (body && typeof body.text === 'string') {
    return body.text;
  }

  if (body && typeof body.message === 'string') {
    return body.message;
  }

  return '';
}



// WEBPACK FOOTER //
// ./src/app/core/utilities/http-error.ts